import ClientOnboardingManagementApi from '@api/ClientOnboardingManagementApi'
import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'

export default {
  [actionTypes.GET_APPLICATION_LIST](context, state) {
    context.commit(mutationTypes.SET_APPLICATION_LIST_LOADING, true)

    new ClientOnboardingManagementApi({
      simulateExample: 'application-list'
    })
      .applicationList()
      .then(response => {
        context.commit(mutationTypes.SET_APPLICATION_LIST, response)
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_APPLICATION_LIST_LOADING, false)
      })
  },

  [actionTypes.GET_RECIPIENTS_LIST](context, options = { applicationId: null }) {
    context.commit(mutationTypes.SET_RECIPIENTS_LIST_LOADING, true)
    new ClientOnboardingManagementApi({
      simulateExample: 'recipient-list'
    })
      .recipientList({ applicationId: options.applicationId })
      .then(response => {
        const temp = JSON.parse(JSON.stringify(response))
        const originalList = JSON.parse(JSON.stringify(response))

        context.commit(mutationTypes.SET_RECIPIENTS_LIST, temp)
        context.commit(
          mutationTypes.SET_ORIGINAL_RECIPIENTS_LIST,
          originalList
        )
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_RECIPIENTS_LIST_LOADING, false)
      })
  },

  [actionTypes.MAKE_BATCH_CALL](context, options = {}) {
    context.commit(mutationTypes.SET_RECIPIENTS_LIST_LOADING, true)
    const oldList = context.getters.originalRecipientsList

    const newList = options.recipientsList
    const batchOperations = diffBatchOperations(oldList, newList)
    if (
      batchOperations.addList.length !== 0 ||
      batchOperations.delList.length !== 0 ||
      batchOperations.updList.length !== 0
    ) {
      new ClientOnboardingManagementApi({
        makeBatchCall: 'make-batch'
      })
        .batch(options, batchOperations)
        .then(response => {
          const temp = JSON.parse(JSON.stringify(response))
          const originalList = JSON.parse(JSON.stringify(response))

          context.commit(mutationTypes.SET_RECIPIENTS_LIST, temp)
          context.commit(
            mutationTypes.SET_ORIGINAL_RECIPIENTS_LIST,
            originalList
          )
          context.commit('SET_ANNOUNCEMENT', 'Recipients Updated')
        })
        .catch(_ => {
          context.commit(mutationTypes.SET_RECIPIENTS_LIST_LOADING, false)
          context.commit(mutationTypes.SET_RECIPIENTS_LIST_TO_ORIGINAL)
        })
    } else {
      context.commit(mutationTypes.SET_RECIPIENTS_LIST_LOADING, false)
      context.commit(mutationTypes.SET_RECIPIENTS_LIST_TO_ORIGINAL)
    }
  },

  [actionTypes.MAKE_RESEND_EMAIL](context, options = { applicationId: null }) {
    context.commit(mutationTypes.SET_RESEND_EMAIL_LOADING, true)
    new ClientOnboardingManagementApi({
      simulateExample: 'resend-email'
    })
      .resendEmail({ applicationId: options.applicationId })
      .then(response => {
        context.commit(mutationTypes.SET_RESEND_EMAIL, response)
        context.commit(mutationTypes.SET_RESEND_EMAIL_LOADING, false)
        context.commit('SET_ANNOUNCEMENT', 'Email sent for ' + response.fullName)
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_RESEND_EMAIL_LOADING, false)
      })
  }
}

function diffBatchOperations(oldList, newList) {
  let add = []
  let del = []
  let upd = []
  let updatedOrNotChanged = []

  if (newList) {
    add = newList.filter(nr => !nr.recipientKey)
    updatedOrNotChanged = newList.filter(nr => !!nr.recipientKey)

    if (updatedOrNotChanged) {
      const exRKey = oldList.map(e => e.recipientKey)

      const nwRKey = updatedOrNotChanged.map(f => f.recipientKey)
      const delKey = exRKey.filter(d => !nwRKey.includes(d))

      delKey.forEach(dk => del.push(oldList.find(e => e.recipientKey == dk)))

      updatedOrNotChanged.forEach(f => {
        const temp = oldList.find(e => e.recipientKey === f.recipientKey)
        if (
          temp.name != f.name ||
          temp.email != f.email ||
          temp.routingOrder != f.routingOrder
        ) {
          upd.push(f)
        }
      })
    } else {
      /// case where only additions happended
      del = []
      upd = []
    }
  } else {
    add = []
    del = oldList
    upd = []
    updatedOrNotChanged = []
  }
  return { addList: add, delList: del, updList: upd }
}
